import { useMemo } from 'react';
import { DraftOfferData } from '@/enterprise/data/useDraftOffer';
import useTakerMarkets, { TakerMarket } from '@/enterprise/data/useTakerMarkets';

export const useTakerMarketsInDraftOffer = (draftOfferData: DraftOfferData | null): TakerMarket[] => {
  const { data: takerMarkets } = useTakerMarkets();

  const takerMarketsInDraftOffer = useMemo(() => {
    if (!draftOfferData || !takerMarkets) {
      return [];
    }

    const { supplierMarkets: supplierMarketsInDraft } = draftOfferData;

    return takerMarkets.filter((tm) => {
      return (
        supplierMarketsInDraft.find((draftSupplierMarket) => {
          return (
            tm.marketUuid === draftSupplierMarket.marketUuid &&
            tm.takerDivisionUuid === draftSupplierMarket.supplierDivisionUuid
          );
        }) !== undefined
      );
    });
  }, [draftOfferData, takerMarkets]);

  return takerMarketsInDraftOffer;
};
